import React, {useState} from 'react';
import {isEmail, setElementAttribute} from "../utils/common-utils.ts";
import ReactDOM from "react-dom/client";
import {renderTextField, renderTextArea, renderEmailField, renderDropdown} from "./fields/FormFields.tsx";

export const renderFormVideoHelpFr = (div: string) => {
    const root = document.getElementById(div)
    if (root) {
        ReactDOM.createRoot(root).render(<React.StrictMode><FormVideoHelpFr/></React.StrictMode>)
    }
}
const FormVideoHelpFr = () => {
    const [choiceOS, setChoiceOS] = useState('select');
    const [choiceProv, setChoiceProv] = useState('select');
    const [connection, setConnection] = useState('');
    const [autreOS, setAutreOS] = useState('');
    const [browser, setBrowser] = useState('select');
    const [browserAutre, setBrowserAutre] = useState('');
    const [city, setCity] = useState('');
    const [errorDetails, setErrorDetails] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const renderChoiceOs = () => {
        const inputData = {
            name: 'operating-system-choice',
            id: 'OSselector',
            label: 'Type de système d\'exploitation',
            option: [
                {label: '- Choisir -', value: 'select'},
                {label: 'Windows', value: 'Windows'},
                {label: 'Mac', value: 'Mac'},
                {label: 'Linux', value: 'Linux'},
                {label: 'Apple iOS - iPad / iPhone', value: 'Apple iOS - iPad / iPhone'},
                {label: 'Andriod', value: 'Andriod'},
                {label: 'Autre', value: 'Autre'},
            ],
            required: true,
            description: 'field_description_OS',
            message: 'Veuillez sélectionner votre système d\'exploitation. Si votre système d\'exploitation n\'est pas dans la liste, veuillez sélectionner « Autre ».',
            errorMessageID: 'OS_error_message',
            visible: false
        };

        return renderDropdown(inputData, choiceOS, setChoiceOS, submitted);
    }

    const renderAutreOS = () => {
        const inputData = {
            name: 'autreOS',
            id: 'otherOS',
            label: 'Système d\'exploitation - Autre',
            type: 'text',
            inputMode: 'text',
            value: '',
            required: false,
            autoComplete: 'off',
            description: 'field_description_OSother',
            message: 'Si votre système d\'exploitation ne figure pas dans la liste, veuillez indiquer le nom de votre système d\'exploitation.',
            errorMessageID: '',
            visible: true
        }
        return renderTextField(inputData, autreOS, setAutreOS, submitted);
    }

    const renderBrowser = () => {
        const inputData = {
            name: 'browser',
            id: 'browserSelect',
            label: 'Type de navigateur',
            required: true,
            option: [
                {label: '- Choisir -', value: '- choisir -'},
                {label: 'Edge', value: 'Edge'},
                {label: 'Firefox', value: 'Firefox'},
                {label: 'Safari', value: 'Safari'},
                {label: 'Chrome', value: 'Chrome'},
                {label: 'Autre', value: 'Autre'},
            ],
            description: 'field_description_browser',
            message: 'Veuillez sélectionner votre navigateur web. Si votre navigateur n\'est pas dans la liste, veuillez sélectionner « Autre ».',
            errorMessageID: 'browser_error_message',
            visible: false
        };

        return renderDropdown(inputData, browser, setBrowser, submitted);
    }

    const renderBrowserAutre = () => {
        const inputData = {
            name: 'browser_autre',
            id: 'other-browser',
            label: 'Navigateur - Autre',
            type: 'text',
            inputMode: 'text',
            value: '',
            required: false,
            autoComplete: 'off',
            description: 'field_description_browserOther',
            message: 'Si votre navigateur Web ne figure pas dans la liste, veuillez indiquer le nom de votre navigateur.',
            errorMessageID: '',
            visible: false
        }
        return renderTextField(inputData, browserAutre, setBrowserAutre, submitted);
    }

    const renderCity = () => {
        const inputData = {
            name: 'city',
            id: 'location',
            label: 'Votre ville',
            type: 'text',
            inputMode: 'text',
            value: '',
            required: true,
            autoComplete: 'address-level2',
            description: 'field_description_city',
            message: 'Veuillez indiquer votre emplacement.',
            errorMessageID: 'location_error_message',
            visible: false
        }
        return renderTextField(inputData, city, setCity, submitted);
    }

    const renderChoiceProv = () => {
        const inputData = {
            name: 'province-territory',
            id: 'province',
            label: 'Votre province / territoire',
            option: [
                {label: '- Choisir -', value: 'select'},
                {label: 'Colombie-britannique', value: 'Colombie-britannique'},
                {label: 'Alberta', value: 'Alberta'},
                {label: 'Saskatchewan', value: 'Saskatchewan'},
                {label: 'Manitoba', value: 'Manitoba'},
                {label: 'Ontario', value: 'Ontario'},
                {label: 'Québec', value: 'Québec'},
                {label: 'Nouveau-Brunswick', value: 'Nouveau-Brunswick'},
                {label: 'Île-du-Prince-Édouard', value: 'Île-du-Prince-Édouard'},
                {label: 'Nouvelle-Écosse', value: 'Nouvelle-Écosse'},
                {label: 'Terre-Neuve-et-Labrador', value: 'Terre-Neuve-et-Labrador'},
                {label: 'Nunavut', value: 'Nunavut'},
                {label: 'Territoires du Nord-Ouest', value: 'Territoires du Nord-Ouest'},
                {label: 'Yukon', value: 'Yukon'},
            ],
            required: true,
            description: 'field_description_province',
            message: 'Veuillez sélectionner votre province ou territoire.',
            errorMessageID: 'province_error_message',
            visible: false
        };

        return renderDropdown(inputData, choiceProv, setChoiceProv, submitted);
    }

    const renderConnection = () => { 
        const inputData = {
            name: 'connection',
            id: 'connection',
            label: 'Type de connexion',
            required: true,
            option: [
                {label: '- Choisir -', value: 'select'},
                {label: 'Modem câble', value: 'Cable'},
                {label: 'Fibre optique', value: 'Fibre'},
                {label: 'Satellite', value: 'Satellite'},
                {label: 'Sans fil fixe', value: 'Fixed Wireless'},
                {label: 'Mobile', value: 'Mobile'},
                {label: 'DSL (Digital Subscriber Line - ligne d\'accès numérique)', value: 'DSL'},
            ],
            description: 'field_description_connection',
            message: 'Veuillez sélectionner votre type de connexion Internet.',
            errorMessageID: 'connection_error_message',
            visible: false
        };
        return renderDropdown(inputData, connection, setConnection, submitted);
    }

    const renderErrorDetails = () => {
        const inputData = {
            name: 'error_details',
            id: 'errorDetails',
            label: 'Veuillez expliquer en détails les difficultés que vous éprouvez.',
            required: true,
            inputMode: 'text',
            description: 'field_description_errorDetails',
            message: 'Veuillez fournir autant de détails que possible, y compris les messages d\'erreur que vous avez pu recevoir.',
            errorMessageID: 'errorDetails_error_message',
            visible: false
        }
        return renderTextArea(inputData, errorDetails, setErrorDetails, submitted);
    }

    const renderEmailDetails = () => {
        const inputData = {
            name: 'email',
            id: 'emailAddress',
            autoComplete: 'email',
            label: 'Courriel',
            required: true,
            description: 'field_description_email',
            message: 'Veuillez fournir votre adresse électronique.',
            errorMessageID: 'email_error_message',
            visible: false,
            success: 'Merci pour votre adresse courriel.'
        }
        return renderEmailField(inputData, emailAddress, setEmailAddress, submitted);
    }

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const hasErrors = !choiceProv || choiceProv === 'select' || choiceProv === '' || !city || !emailAddress || !isEmail(emailAddress) ||
        !choiceOS || choiceOS === 'select' || choiceOS === ''|| !connection || connection === 'select' || connection === '' || !browser || browser === 'select' || browser === '' || !errorDetails;
        setSubmitted(true);
        const mailSubject = "?subject=Submission d'Aide videos";
        const mailBody = `&body=Adresse courriel : ${emailAddress}%0D%0A Ville : ${city}%0D%0A Province : ${choiceProv}%0D%0A Type de systeme d'exploitation : ${choiceOS}%0D%0A Systeme d'exploitation - Autre : ${autreOS}%0D%0A Type de navigateur : ${browser}%0D%0A Navigateur - Autre : ${browserAutre}%0D%0A Type de connexion : ${connection}%0D%0A Details des difficultes : ${errorDetails}%0D%0A`;
        const sendMail = "mailto:videohelp@cpac.ca";
        const errorMessages = document.querySelector("#error_summary") as HTMLElement | null;
        if (hasErrors) {    
            setElementAttribute("error_summary", "aria-labelledby", "error_summary_heading");
            document.getElementById("error_summary")?.focus();
        } else {
            window.open(sendMail + mailSubject + mailBody);
            e.target.reset();
            setChoiceOS('select');
            setChoiceProv('select');
            setConnection('select');
            setAutreOS('');
            setBrowser('select');
            setBrowserAutre('');
            setCity('');
            setErrorDetails('');
            setEmailAddress('');
            setSubmitted(false);
            errorMessages?.removeAttribute("aria-labelledby");
        }
    }

    return (
        <>
            { 
                 <div id="form_wrapper" className="form_wrapper">
                    <h2>Faites-nous savoir comment nous pouvons vous aider</h2>
                    <div id='error_summary' aria-live="assertive" tabIndex={-1}>
                        {submitted && (!choiceProv || choiceProv === 'select' || choiceProv === '' || !city || !emailAddress || !isEmail(emailAddress) ||
                        !choiceOS || choiceOS === 'select' || choiceOS === ''|| !connection || connection === 'select' || connection === '' || !browser || browser === 'select' || browser === '' || !errorDetails) ? <h2 id='error_summary_heading' className='error_message invalid'>Il y a des erreurs dans le formulaire.<br/><span>Veuillez corriger les erreurs et soumettre à nouveau.</span></h2> : null}
                        <ul className="reg-list">
                        {submitted && (!choiceOS || choiceOS === 'select' || choiceOS === '') ? <li id='OS_error_message' className='error_message invalid'><a href="#OSselector"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Veuillez sélectionner votre système d'exploitation.</a></li> : null}
                        {submitted && (!browser || browser === 'select' || browser === '') ? <li id='browser_error_message' className='error_message invalid'><a href="#browserSelect"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Veuillez sélectionner votre navigateur Web.</a></li> : null}
                        {submitted && (!connection || connection === 'select' || connection === '') ? <li id='connection_error_message' className='error_message invalid'><a href="#connection"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Veuillez sélectionner votre type de connexion Internet.</a></li> : null}
                        {submitted && !errorDetails ? <li id='errorDetails_error_message' className='error_message invalid'><a href="#errorDetails"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Veuillez fournir les erreurs que vous rencontrez.</a></li> : null}
                        {submitted && !city ? <li id='location_error_message' className='error_message invalid'><a href="#location"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Veuillez fournir votre emplacement.</a></li> : null}
                        {submitted && (!choiceProv || choiceProv === 'select' || choiceProv === '') ? <li id='province_error_message' className='error_message invalid'><a href="#province"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Veuillez sélectionner votre province ou territoire.</a></li> : null}
                        {submitted && ((!emailAddress) || (!isEmail(emailAddress)) || (emailAddress && !isEmail(emailAddress))) ? <li id='email_error_message' className='error_message invalid'><a href="#emailAddress"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Veuillez fournir une adresse courriel valide.</a></li> : null}
                        </ul>
                    </div>
                     <form aria-label="Formulaire d'aide vidéo" onSubmit={(e) => handleSubmit(e)} noValidate>
                        <div className="form_body">
                            {renderChoiceOs()}
                            {choiceOS === 'Autre' ? renderAutreOS() : ''}
                            {renderBrowser()}
                            {browser === 'Autre' ? renderBrowserAutre() : ''}
                            {renderConnection()}
                            {renderErrorDetails()}
                            {renderCity()}
                            {renderChoiceProv()}
                            {renderEmailDetails()}
                        </div>
                        <div className='form_footer left_label'>
                            <button type="submit" name='submit' className="btn--primary">Envoyer par courrier électronique</button>
                        </div>
                    </form>
                </div>
            }
        </>
    )
}

export default FormVideoHelpFr;